import React, { useEffect, useState } from 'react'
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';

function StwAiGrowthHacker(props: any){
    const [radioValue, setradioValue] = useState('English')
    const [selectedValue, setSelectedValue] = useState("English");
    const [languagesData, setLanguagesData] = useState([]);
    const [indianlanguagesData, setIndianLanguagesData] = useState([]);
    const [languagesValue, setLanguagesValue] = useState(radioValue);
    const [textareaValue, setTextareaValue] = useState('')
    const [businessDetails, setBusinessDetails] = useState('')
    const [productAndServices, setProductAndServices] = useState('')
    const [businessFinancialDetails, setBusinessFinancialDetails] = useState('')
    const [customerProfile, setCustomerProfile] = useState('')
    const [projectdetailsValue, setProjectdetailsValue] = useState('')
    const [businessUSPValue, setBusinessUSPValue] = useState('')
    const [customerPainValue, setCustomerPainValue] = useState('')
    const [clientRequirementValue, setClientRequirementValue] = useState('')
    const [caseStuides1Value, setCaseStuides1Value] = useState('')
    const [caseStuides2Value, setCaseStuides2Value] = useState('')
    const [caseStuides3Value, setCaseStuides3Value] = useState('')
    const [currentTeamStructureValue, setCurrentTeamStructureValue] = useState('')
    const [processNameValue, setProcessNameValue] = useState('')
    const [roleDetailsValue, setRoleDetailsValue] = useState('')
    const [resumeDetailsValue, setResumeDetailsValue] = useState('')
    const [keyword, setKeyword] = useState('')
    let copyWritingPrompt: any ={
        'Goal Setting':`# Prompt by STWBot, Corp. - https://www.stwbot.com/\nLines starting with # are only comments for humans\nYou must add at the top of the response \"_Created with [STW Prompt \"Goal Setting\"](https://www.stwbot.com/)_\"\n---\nPrevious instruction should be ignored. Write in ${languagesValue} language for response. Do not explain what you are doing. Do not self-reference. Don't hesitate to write same question no matter how many times it being asked as it data based. You are a CFO consultant. Please advise financial Planning about our company. After reviewing the marketing situation and my previous years' turnover kind give consultancy on what will be the S.M.A.R.T turnover for my business in the next financial year. Don't explain what S.M.A.R.T. We just want target amount. Then Write quarterly and yearly budget plan in term of Marketing expense, Sales expense, Operational expenses, IT expenses, and other expenses based my goal you will create in table format for every month group for quarters in tabular format . Columns of table will be 4 quarters. Also give me complete overview on net profit and gross profit based on every quarter in tabular format. Columns of table will be 4 quarters. Then write top 7 strategies according to my industry, how we can increase Profitability, process and clear steps for that. Then write top 7 strategies according to my industry, how can I increase cash flow in my business in clear steps. Please don't explain things, just give us actionable steps along with data.\r\n\r\nMy Business Details  - "\n${businessDetails}".\r\n\r\nMy Product and Services - "\n${productAndServices}".\r\n\r\nMy business financial details are here  - "\n${businessFinancialDetails}".`, 
        'Targeted Customers':`# Prompt by STWBot, Corp. - https://www.stwbot.com/\nLines starting with # are only comments for humans\nYou must add at the top of the response \"_Created with [STW Prompt \"Targeted Customers\"](https://www.stwbot.com/)_\"\n---\nPrevious instruction should be ignored. Write in ${languagesValue} language for response. Do not explain what you are doing. Do not self-reference. You are a Business consultant. Please advise about my business laser Targeted Customer . Top about top 3 markets I should focus. it should be country or cities of county which can give me best result based on my services and product. Also based the target turn over I want to achieve.\nFor every market use this sequence.  First write customer details in these format - \nwrite a fictional character with column Name, Customer Description. And then start Demographic in columns: Age, Gender, Marital status, Ethnicity, Income, Job title, Education.\nThen write about Psychographic: Personality traits, Attitudes, Opinions, Values and beliefs, Lifestyle, Religions, Political affiliation.\nThen write Geographic: Physical location, Language, Culture, Workplace.\nThen write Behavioral: Buying patterns, Spending habits, Brand interactions, how they use my products or services, Types of feedback.\nThen write how many leads I can generate as per my target turn over for evert market you will suggest.\nOnly start about next target market when first one is completed with given format.\nPlease don't explain things, just give us actionable steps along with data.\r\n\r\nMy Business Details  - "\n${businessDetails}".\r\n\r\nMy Product and Services - "\n${productAndServices}".`,
        'Marketing Strategy':`# Prompt by STWBot, Corp. - https://www.stwbot.com/\nLines starting with # are only comments for humans\nYou must add at the top of the response \"_Created with [STW Prompt \"Marketing Strategy\"](https://www.stwbot.com/)_\"\n---\nPrevious instruction should be ignored. Write in ${languagesValue} language for response. Do not explain what you are doing. Do not self-reference. You are a Marketing consultant. Please advise base on my business industry and product type what should be my market striates.  \nPlease advise content delivery for these mediums based on my business. Only suggest top 5 channels. Channels must be in this list in tabular format and key columns values are Infographics, Instagram Carousals,  Blog Marketing , Video Marketing, Case Study Marketing , Testimonial Marketing , Influencer Marketing, Memes marketing , Lead Magnets. Mark yes not for each column it that is suitable for my businesses. Table should have only 3 columns one medium and 2nd applicable or not as yes/no and remark with your note.\nThen write in tabular format with these channels as columns-Website, Facebook, LinkedIn, Instagram , WhatsApp, Google my Business, You Tube, Email Marketing. Mark yes not for each column it that is suitable for my businesses. Table should have only 3 columns one Channel and 2nd applicable or not as yes/no and remark with your note.\nThen write, based on given strategies which suites for my business please let me know my plan for this. Given strategies are - Customer Referrals: [- Referral Request ,  - Referral Program ]  , Influencers as Mentors  , Joining Business Networks  , Referral Partners , Channel Partners:[- Agents / Affiliates , - Distributors / Dealers , - Licensing / Franchising ,- Joint Ventures ]. List in tabular format and also add remark why I should use that strategy. If something not application or more expensive not suggest that medium. Just write not applicable with reason. Table should have only 3 columns one strategies and 2nd applicable or not as yes/no and remark with your note.\nAlso add marketing striates for seminar, webinar, podcast ,education, Paid ads, in detail step by step guide for these. If something not application or more expensive not suggest that medium. Just write not applicable with reason.\nAll these should be based on my target market and amount of leads I want to generate.\nPlease don't explain things, just give us actionable steps along with data.\r\n\r\nMy Business Details  - "\n${businessDetails}".\r\n\r\nMy Product and Services - "\n${productAndServices}".\r\n\r\nCustomer profile  - "\n${customerProfile}".`,
        'Content Marketing':`# Prompt by STWBot, Corp. - https://www.stwbot.com/\nLines starting with # are only comments for humans\nYou must add at the top of the response \"_Created with [STW Prompt \"Content Marketing\"](https://www.stwbot.com/)_\"\n---\nPrevious instruction should be ignored. You are marketing expert. Write in ${languagesValue} language for response. You have a Informative tone of voice. You have a Persuasive writing style. Do not self-reference. Do not explain what you are doing. I want keywords for these categories- need, desire, problem, fantasy. Write 15 keywords for every category based on business services and customer profile. It must be in tabular format columns category, keywords.\nPlease don't explain things, just give us actionable steps along with data.\r\n\r\nMy Business Details  - "\n${businessDetails}".\r\n\r\nMy Product and Services - "\n${productAndServices}".\r\n\r\nCustomer profile  - "\n${customerProfile}".`,
        'Sale Meeting Frame work':`# Prompt by STWBot, Corp. - https://www.stwbot.com/\nLines starting with # are only comments for humans\nYou must add at the top of the response \"_Created with [STW Prompt \"Sale Meeting Frame work\"](https://www.stwbot.com/)_\"\n---\nPrevious instruction should be ignored. Write in ${languagesValue} language for response. Do not explain what you are doing. Do not self-reference. You are a Business consultant. We have our sale framework meeting in 6 steps those are - schedule, invite, confirm, prepare, meeting, follow-up. Please write plot of every step based on my business and customer details.\nFirst write content of communication for this step which is best suitable for my business and customer type.\nIn every step when write about step content please consider this. First write type fo Communcation it is email of phone call or in person communication.\nIf step communication is email must write catchy subject line and then body.\nIf phone call then write possible sample conversation script on phone call.\nThen write some persuasive lines which can motivate customer to take action for this step. It can be more than one line  based on different type of customer.\nThen write 7 actionable steps which we should need take for that step to productive.\nThen write what are the  7 things to avoid in that step to make that step very effective.\nAlso whenever talk about any tool give first preference to Microsoft 365 tools.\r\n\r\nPlease don't explain things, just give us actionable steps along with best suitable content.\r\n\r\nMy Business Details  - "\n${businessDetails}".\r\n\r\nMy Product and Services - "\n${productAndServices}".\r\n\r\nCustomer profile  - "\n${customerProfile}".`,
        'Powerful Sale Presentation Tips':`# Prompt by STWBot, Corp. - https://www.stwbot.com/\nLines starting with # are only comments for humans\nYou must add at the top of the response \"_Created with [STW Prompt \"Powerful Sale Presentation Tips\"](https://www.stwbot.com/)_\"\n---\nPrevious instruction should be ignored. Write in ${languagesValue} language for response. Do not explain what you are doing. Do not self-reference. You are a Business consultant.  Please write a tips to make power full sale prestation for my business.\nFirst write how should I set context so I look different than other competitors.\nThen write what best quote or article I can put to back my presentation. It must be authentic so people related with it. Don't be creative for this pick best suitable for my business.\nThen write a beauties quote which also backup my presentation. It must be famous so people related with it. Don't be creative for this pick best suitable for my business.\nThen write what are the possible 10 questions customer can ask and what best possible answer to it.\nThen write what best possible way to close my presentation to customer will be impressed. Or be long term relationship with us.\r\n\r\nMy Business Details  - "\n${businessDetails}".\r\n\r\nMy Product and Services - "\n${productAndServices}".\r\n\r\nBusiness USP - "\n${businessUSPValue}".\r\n\r\nCustomerPain - "${customerPainValue}".`,
        'Case Studies':`# Prompt by STWBot, Corp. - https://www.stwbot.com/\nLines starting with # are only comments for humans\nYou must add at the top of the response \"_Created with [STW Prompt \"Case Studies\"](https://www.stwbot.com/)_\"\n---\nPrevious instruction should be ignored. Write in ${languagesValue} language for response. Do not explain what you are doing. Do not self-reference. You are a Business consultant. You are sale person who understand case studies and write in very simple way.\nWrite a case studies for given project details.\nFirst write Client details and provider details.\nThen write problem statement in very informative way. It should be also detailed not less than 100 words.\nThen write solution which any business owner can understand. It should be also detailed not less than 100 words.\nAnd Then write process Steps using Microsoft 365 tools.\nThen write 7 benefit of having these kind of solution.\r\n\r\nOur Project details is here - "${projectdetailsValue}"`,
        'Sale Proposal':`# Prompt by STWBot, Corp. - https://www.stwbot.com/\nLines starting with # are only comments for humans\nYou must add at the top of the response \"_Created with [STW Prompt \"Sale Proposal\"](https://www.stwbot.com/)_\"\n---\nPrevious instruction should be ignored. Write in ${languagesValue} language for response. Do not explain what you are doing. Do not self-reference. You are a Business consultant.  Write a business perposal base on client requirement given below.\nFirst write our understand about client problem. Very detailed not less than 100 words.\nThen write our tailored made solution for requirement. Very detailed not less than 100 words.\nThen write about our company.  Very detailed not less than 100 words.\nAnd why to choose us. Very detailed not less than 100 words.\r\n\r\nMy Business Details  - "\n${businessDetails}".\r\n\r\nMy Product and Services - "\n${productAndServices}".\r\n\r\nBusiness USP - "\n${businessUSPValue}".\r\n\r\nClient Requirement - "\n${clientRequirementValue}".\r\n\r\nCase Stuides 1 - "\n${caseStuides1Value}".\r\n\r\nCase Stuides 2 - "\n${caseStuides2Value}".\r\n\r\nCase Stuides 3 - "\n${caseStuides3Value}".`,
        'Meeting Script':`# Prompt by STWBot, Corp. - https://www.stwbot.com/\nLines starting with # are only comments for humans\nYou must add at the top of the response \"_Created with [STW Prompt \"Meeting Script\"](https://www.stwbot.com/)_\"\n---\nPrevious instruction should be ignored. Write in ${languagesValue} language for response. Do not explain what you are doing. Do not self-reference.\nPlease write complete script for in person communication, which should include meeting opening script, exploring customer requirement in terms of possible pain points possible 15 question to ask to explore need, desire, problems and fantasy, then script for our product show value, then closing of meeting in positive way to customer can connect again. Please write like a first customer conversation. Also make sure how it should be control communication in every segment what things should be avoid so communication will always in control format.\r\n\r\nMy Business Details  - "\n${businessDetails}".\r\n\r\nMy Product and Services - "\n${productAndServices}".\r\n\r\nCustomer profile  - "\n${customerProfile}".`,
        'Team Structure':`# Prompt by STWBot, Corp. - https://www.stwbot.com/\nLines starting with # are only comments for humans\nYou must add at the top of the response \"_Created with [STW Prompt \"Team Structure\"](https://www.stwbot.com/)_\"\n---\nPrevious instruction should be ignored. Write in ${languagesValue} language for response. Do not explain what you are doing. Do not self-reference. You are CEO of company. Please advise about my business organizational structure . First write best team hierarchy along with roles in tabular format with column Role Name, parent role name, third column for your suggestion on it should be inhouse or outsourced.\nThen right each role details in segment - knowledge required, skill required, attitude required, responsibility, job description in in detailed way in tabular format for every role. Table first column will be segment and next will be description of that segment. Description must be detailed not less than 100 words.\nPlease don't explain things, just give us actionable steps along with data.\r\n\r\nMy Business Details  - "\n${businessDetails}".\r\n\r\nMy Product and Services - "\n${productAndServices}".\r\n\r\nCurrent Team Structure - "\n${currentTeamStructureValue}".`,  
        'Process Automation Adviser':`# Prompt by STWBot, Corp. - https://www.stwbot.com/\nLines starting with # are only comments for humans\nYou must add at the top of the response \"_Created with [STW Prompt \"Process Automation Adviser\"](https://www.stwbot.com/)_\"\n---\nPrevious instruction should be ignored. Write in ${languagesValue} language for response. Do not explain what you are doing. Do not self-reference. You are CEO of company. \nFirst write about ${processNameValue} Process - \nWrite about process along with sub process in very detailed way like a process flow just using Arrow in very detailed way.\nThen List all those steps and list tools we can use to automate those flow. Prefer Microsoft tools but also others if they are good. Also explain how they will help to automate process. For Add also add Facebook, google other social media sites.\nThen write a report sample format to track process of this process as process manager. List all those columns  along with dummy data in tabular format. and how to check real time data.\nThen advise how power automate can automate this process using Microsoft 365, just advise as flow. Don't write code.\nThen Write how much time it can save in your business and how cost it can save as total number of employee given in business details.\r\n\r\nMy Business Details  - "\n${businessDetails}".`,
        'Resume Assessment':`# Prompt by STWBot, Corp. - https://www.stwbot.com/\nLines starting with # are only comments for humans\nYou must add at the top of the response \"_Created with [STW Prompt \"Resume Assessment\"](https://www.stwbot.com/)_\"\n---\nPrevious instruction should be ignored. Write in ${languagesValue} language for response. Do not explain what you are doing. Do not self-reference. You are hiring manager for role given in details. Role responsibility is also given below and resume details as well please check resume and suggest this candidate is suitable for given role. First start with it is suitable or not suitable.\r\n\r\nThen write note why it is not suitable or suitable. For this role.\r\n\r\nRole details - "\n${roleDetailsValue}".\r\n\r\nResume details - "${resumeDetailsValue}".`,
        'Question for Interview':`# Prompt by STWBot, Corp. - https://www.stwbot.com/\nLines starting with # are only comments for humans\nYou must add at the top of the response \"_Created with [STW Prompt \"Question for Interview\"](https://www.stwbot.com/)_\"\n---\nPrevious instruction should be ignored. Write in ${languagesValue} language for response. Do not explain what you are doing. Do not self-reference. You are hiring manager for role given in details. Role responsibility is also given below and resume details as well please check resume and suggest - \nBased on experience 10 questions which needs to ask to check his expertise and possible answers? If person is technical then write technical question based on technology required for role not all technology shown in resume.\r\nThen Write 5 indirect questions to check this skills for this job role and possible answers?\r\nThen write 5 indirect questions to check his attitude for this job role and possible answers?\r\n\r\nRole details - "\n${roleDetailsValue}".\r\n\r\nResume details - "\n${resumeDetailsValue}".`
    }
    let templateValue: any = copyWritingPrompt[props.templateValue] ? copyWritingPrompt[props.templateValue] : ''
    useEffect(() => {
        setTextareaValue(templateValue)
    }, [templateValue])
    useEffect(() => {
        resetValue()
    }, [props.templateValue])
    useEffect(() => {
        const data: any = []
        for (const key in indianLanguages) {
            const value: any = {
                name: '',
                value: ''
            }
            value.value = key;
            value.name = indianLanguages[key];
            data.push(value)
        }
        setIndianLanguagesData(data) 
    },[])
    const onChangeRadio = (event: any) => {
        const value = event.target.value;
        setSelectedValue(value);
        setradioValue(value)
        if(value === 'Other languages'){
            const data: any = []
            for (const key in languages) {
                const value: any = {
                    name: '',
                    value: ''
                }
                value.value = key;
                value.name = languages[key];
                data.push(value)
            }
            setLanguagesData(data)
            setLanguagesValue('Arabic')
        } else {
            setLanguagesValue(value)
            setLanguagesData([])
        }
    }
    const onChangeLanguages = (event: any) => {
        const value = event.target.value;
        setLanguagesValue(value)
    }
    const onChangeFinancialDetails = (event: any) => {
        const value = event.target.value
        setBusinessFinancialDetails(value)
    }
    const onChangeBusinessDetails = (event: any) => {
        const value = event.target.value
        setBusinessDetails(value)
    }
    const onChangeProductAndServices = (event: any) => {
        const value = event.target.value
        setProductAndServices(value)
    }
    const onChangeCustomerProfile = (event: any) => {
        const value = event.target.value
        setCustomerProfile(value)
    } 
    const onChangeTextarea = (event: any) => {
        const value = event.target.value
        setTextareaValue(value)
    }
    const onChangeProjectdetailsValue = (event: any) => {
        const value = event.target.value
        setProjectdetailsValue(value)
    }
    const onChangeBusinessUSPValue = (event: any) => {
        const value = event.target.value
        setBusinessUSPValue(value)
    }
    const onChangeCustomerPainValue = (event: any) => {
        const value = event.target.value
        setCustomerPainValue(value)
    }
    const onChangeClientRequirement = (event: any) => {
        const value = event.target.value
        setClientRequirementValue(value)
    }
    const onChangeCaseStuides1Value = (event: any) => {
        const value = event.target.value
        setCaseStuides1Value(value)
    }
    const onChangeCaseStuides2Value = (event: any) => {
        const value = event.target.value
        setCaseStuides2Value(value)
    }
    const onChangeCaseStuides3Value = (event: any) => {
        const value = event.target.value
        setCaseStuides3Value(value)
    }
    const onChangeCurrentTeamStructureValue = (event: any) => {
        const value = event.target.value
        setCurrentTeamStructureValue(value)
    }
    const onChangesProcessNameValue = (event:any) => {
        const value = event.target.value
        setProcessNameValue(value)
    }
    const onChangeRoleDetailsValue = (event:any) => {
        const value = event.target.value
        setRoleDetailsValue(value)
    }
    const onChangeResumeDetailsValue = (event:any) => {
        const value = event.target.value
        setResumeDetailsValue(value)
    }
    const templateChangeValue = () => {
        const setValue = []
        if(businessDetails){
            setValue.push(businessDetails)
        } else if(productAndServices) {
            setValue.push(productAndServices)
        } else if(businessFinancialDetails) {
            setValue.push(businessFinancialDetails)
        } else if(customerProfile) {
            setValue.push(customerProfile)
        } else if(businessUSPValue) {
            setValue.push(businessUSPValue)
        } else if(caseStuides1Value) {
            setValue.push(caseStuides1Value)
        } else if(caseStuides2Value) {
            setValue.push(caseStuides2Value)
        } else if(caseStuides3Value) {
            setValue.push(caseStuides3Value)
        } else if(currentTeamStructureValue) {
            setValue.push(currentTeamStructureValue)
        } else if(processNameValue) {
            setValue.push(processNameValue)
        } else if(resumeDetailsValue) {
            setValue.push(resumeDetailsValue)
        }
        const finalValue = JSON.stringify(setValue);
        setKeyword(finalValue)
        props.executeTemplateButton(textareaValue, finalValue)
    }
    const executeTemplateButton = () => {
        templateChangeValue()
    }
    
    const getButtonVisiblety = () => {
        const value = props.templateValue
        switch(value) {
            case 'Goal Setting':
                return businessDetails && productAndServices && businessFinancialDetails ? false : true
            case 'Targeted Customers':
                return businessDetails && productAndServices ? false : true 
            case 'Marketing Strategy':
                return businessDetails && productAndServices && customerProfile ? false : true
            case 'Content Marketing':
                return businessDetails && productAndServices && customerProfile ? false : true
            case 'Sale Meeting Frame work':
                return businessDetails && productAndServices && businessUSPValue ? false : true
            case 'Case Studies':
                return projectdetailsValue ? false : true
            case 'Sale Proposal':
                return businessDetails && productAndServices && businessUSPValue && caseStuides1Value && caseStuides2Value && caseStuides3Value ? false : true
            case 'Meeting Script':
                return businessDetails && productAndServices && customerProfile ? false : true
            case 'Team Structure':
                return businessDetails && productAndServices && currentTeamStructureValue ? false : true
            case 'Process Automation Adviser':
                return businessDetails && processNameValue ? false : true
            case 'Resume Assessment':
                return roleDetailsValue && resumeDetailsValue ? false : true
            case 'Question for Interview':
                return roleDetailsValue && resumeDetailsValue ? false : true
            default:
                return true;
        }
    }
    const resetValue = () => {
        setBusinessFinancialDetails('')
        setBusinessDetails('')
        setProductAndServices('')
        setCustomerProfile('')
        setBusinessUSPValue('')
        setProjectdetailsValue('')
        setCaseStuides1Value('')
        setCaseStuides2Value('')
        setCaseStuides3Value('')
        setCurrentTeamStructureValue('')
        setProcessNameValue('')
        setRoleDetailsValue('')
        setResumeDetailsValue('')
    }
    return(
        <div className='marketing'>
            <div className="row">
                <div className="col-sm-12 mt-2"><p></p></div>
                <div className="col-sm-12 mt-2">
                    <div id="reverse-radio" className="mb-3">
                        {indianlanguagesData.map((item, i) => 
                            <Form.Check
                                key={i}
                                reverse
                                onChange={onChangeRadio}
                                label={item['name']}
                                checked={selectedValue === item['name']}
                                name="group1"
                                value={item['name']}
                                type='radio'
                                id={`reverse-radio-${i}`}
                            />
                        )}
                    </div>
                </div>
                {radioValue === "Other languages" && <div className="col-sm-4 mt-2">
                    <Form.Label htmlFor="languages">Languages:</Form.Label>
                    <Form.Select id="languages" 
                        value={languagesValue}
                        onChange={onChangeLanguages}
                    >
                        {languagesData.map((item, i) => <option key={i} value={item['name']}>{item['name']}</option>)}
                    </Form.Select>  
                </div>}
                {props.templateValue === "Goal Setting" || 
                props.templateValue === "Targeted Customers" || 
                props.templateValue === "Marketing Strategy" || 
                props.templateValue === "Content Marketing" ||  
                props.templateValue === "Sale Meeting Frame work" || 
                props.templateValue === "Powerful Sale Presentation Tips" ||
                props.templateValue === "Sale Proposal" || 
                props.templateValue === "Meeting Script" || 
                props.templateValue === "Team Structure" || 
                props.templateValue === "Process Automation Adviser" ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="businessDetails">Business Details</Form.Label>
                    <Form.Control 
                        id="businessDetails"
                        value={businessDetails}
                        onChange={onChangeBusinessDetails}
                        as='textarea' 
                        rows={3}
                    />
                </div> : <></>}
                {props.templateValue === "Goal Setting" || 
                props.templateValue === "Targeted Customers" || 
                props.templateValue === "Marketing Strategy" || 
                props.templateValue === "Content Marketing" ||  
                props.templateValue === "Sale Meeting Frame work" || 
                props.templateValue === "Powerful Sale Presentation Tips" ||
                props.templateValue === "Sale Proposal" || 
                props.templateValue === "Meeting Script" || 
                props.templateValue === "Team Structure"  ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="productAndServices">Product and Services:</Form.Label>
                    <Form.Control 
                        id="productAndServices"
                        value={productAndServices}
                        onChange={onChangeProductAndServices}
                        as='textarea' 
                        rows={3}
                    />
                </div> : <></>}
                {props.templateValue === "Goal Setting" ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="businessfinancialdetails">Business financial details:</Form.Label>
                    <Form.Control 
                        id="businessfinancialdetails"
                        value={businessFinancialDetails}
                        onChange={onChangeFinancialDetails}
                        as='textarea' 
                        rows={3}
                    />
                </div> : <></>}
                {props.templateValue === "Marketing Strategy" || 
                props.templateValue === "Content Marketing" || 
                props.templateValue === "Sale Meeting Frame work" || props.templateValue === "Meeting Script" ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="customerProfile">Customer Profile:</Form.Label>
                    <Form.Control 
                        id="customerProfile"
                        value={customerProfile}
                        onChange={onChangeCustomerProfile}
                        as='textarea' 
                        rows={3}
                    />
                </div> : <></>}
                {props.templateValue === "Powerful Sale Presentation Tips" ||
                props.templateValue === "Sale Proposal" ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="businessUSP">Business USP:</Form.Label>
                    <Form.Control 
                        id="businessUSP"
                        value={businessUSPValue}
                        onChange={onChangeBusinessUSPValue}
                        as='textarea' 
                        rows={3}
                    />
                </div> : <></>}
                {props.templateValue === "Powerful Sale Presentation Tips" ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="customerPain">Customer Pain:</Form.Label>
                    <Form.Control 
                        id="customerPain"
                        value={customerPainValue}
                        onChange={onChangeCustomerPainValue}
                        as='textarea' 
                        rows={3}
                    />
                </div> : <></>}
                {props.templateValue === "Case Studies" ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="projectdetails">Our Project details:</Form.Label>
                    <Form.Control 
                        id="projectdetails"
                        value={projectdetailsValue}
                        onChange={onChangeProjectdetailsValue}
                        as='textarea' 
                        rows={3}
                    />
                </div> : <></>}
                {props.templateValue === "Sale Proposal" ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="clientRequirement">Client Requirement:</Form.Label>
                    <Form.Control 
                        id="clientRequirement"
                        value={clientRequirementValue}
                        onChange={onChangeClientRequirement}
                        as='textarea' 
                        rows={3}
                    />
                </div> : <></>}
                {props.templateValue === "Sale Proposal" ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="caseStuides1">Case Stuides 1</Form.Label>
                    <Form.Control 
                        id="caseStuides1"
                        value={caseStuides1Value}
                        onChange={onChangeCaseStuides1Value}
                        as='textarea' 
                        rows={3}
                    />
                </div> : <></>}
                {props.templateValue === "Sale Proposal" ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="caseStuides2">Case Stuides 2</Form.Label>
                    <Form.Control 
                        id="caseStuides2"
                        value={caseStuides2Value}
                        onChange={onChangeCaseStuides2Value}
                        as='textarea' 
                        rows={3}
                    />
                </div> : <></>}
                {props.templateValue === "Sale Proposal" ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="caseStuides3">Case Stuides 3</Form.Label>
                    <Form.Control 
                        id="caseStuides3"
                        value={caseStuides3Value}
                        onChange={onChangeCaseStuides3Value}
                        as='textarea' 
                        rows={3}
                    />
                </div> : <></>}
                {props.templateValue === "Team Structure" ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="currentTeamStructure">Current Team Structure</Form.Label>
                    <Form.Control 
                        id="currentTeamStructure"
                        value={currentTeamStructureValue}
                        onChange={onChangeCurrentTeamStructureValue}
                        as='textarea' 
                        rows={3}
                    />
                </div> : <></>}
                {props.templateValue === "Process Automation Adviser" ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="processName">Process Name</Form.Label>
                    <Form.Control 
                        id="processName"
                        value={processNameValue}
                        onChange={onChangesProcessNameValue}
                        type="text"
                        aria-describedby="Topic"
                    />
                </div> : <></>}
                {props.templateValue === "Resume Assessment" || props.templateValue === "Question for Interview" ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="roleDetails">Role Details</Form.Label>
                    <Form.Control 
                        id="roleDetails"
                        value={roleDetailsValue}
                        onChange={onChangeRoleDetailsValue}
                        as='textarea' 
                        rows={3}
                    />
                </div> : <></>}
                {props.templateValue === "Resume Assessment" || props.templateValue === "Question for Interview" ? <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="resumeDetails">Resume Details</Form.Label>
                    <Form.Control 
                        id="resumeDetails"
                        value={resumeDetailsValue}
                        as='textarea' 
                        rows={3}
                        onChange={onChangeResumeDetailsValue}
                    />
                </div> : <></>}
                {/* <div className="col-sm-12  mt-2">
                    <Form.Label htmlFor="ptemplate">Prompt Template</Form.Label>
                    <Form.Control 
                        id="ptemplate"
                        value={textareaValue}
                        onChange={onChangeTextarea}
                        as='textarea' 
                        rows={10}
                    />dchrome://settings/searchEngines
                    
                </div> */}
            </div>
            <div className="row">
                <div className="col-sm-12  mt-2">
                    <Button id="executeTemplate" onClick={executeTemplateButton} disabled={getButtonVisiblety()} >Execute Template</Button>
                </div>
            </div>
        </div>
    )   
}

export default StwAiGrowthHacker;


const indianLanguages: any = {
    "Assamese":"Assamese",
    "Bengali":"Bengali",
    "Bodo":"Bodo",
    "Dogri":"Dogri",
    "English": "English",
    "Gujarati":"Gujarati",
    "Hindi":"Hindi",
    "Kannada":"Kannada",
    "Kashmiri":"Kashmiri",
    "Konkani":"Konkani",
    "Maithili":"Maithili",
    "Malayalam":"Malayalam",
    "Marathi":"Marathi",
    "Meitei":"Meitei",
    "Nepali":"Nepali",
    "Odia":"Odia",
    "Punjabi":"Punjabi",
    "Sanskrit":"Sanskrit",
    "Santali":"Santali",
    "Sindhi":"Sindhi",
    "Tamil":"Tamil",
    "Telugu":"Telugu",
    "Urdu":"Urdu",
    "Other languages": "Other languages"
}

const languages: any = {
    "arabic": "Arabic",
    "bulgarian": "Bulgarian",
    "burmese": "Burmese",
    "czech": "Czech",
    "danish": "Danish",
    "dutch": "Dutch",
    "french": "French",
    "german": "German",
    "greek": "Greek",
    "hungarian": "Hungarian",
    "indonesian": "Indonesian",
    "italian": "Italian",
    "japanese": "Japanese",
    "javanese": "Javanese",
    "korean": "Korean",
    "mandarin chinese": "Mandarin Chinese",
    "polish": "Polish",
    "portuguese": "Portuguese",
    "romanian": "Romanian",
    "russian": "Russian",
    "spanish": "Spanish",
    "swedish": "Swedish",
    "thai": "Thai",
    "turkish": "Turkish",
    "ukranian": "Ukranian",
    "urdu": "Urdu",
    "vietnamese": "Vietnamese",
    "wu chinese": "Wu Chinese",
    "yue chinese": "Yue Chinese"
}

const voicetones: any = {
    "authoritative": "Authoritative",
    "caring": "Caring",
    "casual": "Casual",
    "cheerful": "Cheerful",
    "coarse": "Coarse",
    "conservative": "Conservative",
    "conversational": "Conversational",
    "creative": "Creative",
    "dry": "Dry",
    "edgy": "Edgy",
    "enthusiastic": "Enthusiastic",
    "expository": "Expository",
    "formal": "Formal",
    "frank": "Frank",
    "friendly": "Friendly",
    "fun": "Fun",
    "funny": "Funny",
    "humorous": "Humorous",
    "informative": "Informative",
    "irreverent": "Irreverent",
    "journalistic": "Journalistic",
    "matteroffact": "Matter of fact",
    "nostalgic": "Nostalgic",
    "objective": "Objective",
    "passionate": "Passionate",
    "poetic": "Poetic",
    "playful": "Playful",
    "professional": "Professional",
    "provocative": "Provocative",
    "quirky": "Quirky",
    "respectful": "Respectful",
    "romantic": "Romantic",
    "sarcastic": "Sarcastic",
    "serious": "Serious",
    "smart": "Smart",
    "snarky": "Snarky",
    "subjective": "Subjective",
    "sympathetic": "Sympathetic",
    "trendy": "Trendy",
    "trustworthy": "Trustworthy",
    "unapologetic": "Unapologetic",
    "upbeat": "Upbeat",
    "witty": "Witty"
}
const writingStyles: any = {
    "academic": "Academic",
    "analytical": "Analytical",
    "argumentative": "Argumentative",
    "conversational": "Conversational",
    "creative": "Creative",
    "critical": "Critical",
    "descriptive": "Descriptive",
    "epigrammatic": "Epigrammatic",
    "epistolary": "Epistolary",
    "expository": "Expository",
    "informative": "Informative",
    "instructive": "Instructive",
    "journalistic": "Journalistic",
    "metaphorical": "Metaphorical",
    "narrative": "Narrative",
    "persuasive": "Persuasive",
    "poetic": "Poetic",
    "satirical": "Satirical",
    "technical": "Technical"
}